<template>
  
    <div id="profiles_wrapper" :class="{'open': profilesOpen}">
        <div class="min-vh-100 brown-bg d-flex align-items-center d-lg-block">
            <div class="container py-5">
                <div class="row justify-content-end">
                    <div class="col col-9 nudge-right">
                        <h2 ref="profiles_headline" tabindex="-1" class="h1 highlight text-right mt-lg-5"><span class="py-1 py-lg-3">{{ $t($parent.iKey('profiles_section', 'headline', 'text')) }}</span></h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col col-lg-7 mt-5 mt-lg-3 ">
                        <p class="explainer2 rotate d-none d-lg-block">{{ $t($parent.iKey('profiles_section', 'description', 'text')) }}</p>
                        <div class="title2 d-lg-none rotate">{{ $t($parent.iKey('profiles_section', 'description', 'text')) }}</div>
                    </div>
                </div>
                <ul ref="icons_wrapper" id="icons_wrapper" class="row mt-5 pb-5 d-none d-lg-flex" role="directory">
                    <li ref="profile_icon" class="icon col col-4 d-flex align-items-center justify-content-center bg-lazy" v-for="i in items" 
                        :key="i.id" 
                        v-lazy:background-image="i.icon.url_resized_fit">
                        
                        <button class="btn-reset name-card-wrapper" v-on:click="openProfileDetails(i.id)">
                            <div class="name-card" :class="{'active': i.id == scrolledProfileId }">
                                <div :style="'background-color: #' + i.hex_code" class="p-3 side front d-flex justify-content-center align-items-center">
                                    <h4 :style="'color: #' + i.secondary_hex_code">{{ i.first_name }}</h4>
                                </div>
                                <div :style="'background-color: #' + i.secondary_hex_code" class="p-3 side back d-flex justify-content-center align-items-center">
                                    <h5 :style="'color: #' + i.hex_code">{{ $t($parent.iKey('related_upstander_profiles', i, 'issue')) }}</h5>
                                </div>
                            </div>
                        </button>
                    </li>
                </ul>
            </div>
        </div>
        <ProfileDetails 
            ref="profile_details"
            :aria-hidden="profilesOpen ? 'false' : 'true'"
            :items="items" 
            :profileId="profileId" 
            :profilesOpen="profilesOpen"
            @closeProfileDetails="closeProfileDetails"
            @scrolledToProfile="scrolledToProfile">
        </ProfileDetails>
        
    </div>
  
</template>

<script>
import ProfileDetails from '@/components/profiles/ProfileDetails'
import { TweenLite } from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'
ScrollToPlugin; // needed so ScrollToPlugin gets regsitered w webpack.

export default {
  name: 'Profiles',
  components: {
      ProfileDetails
  },
  props: [
    'items',
    'profiles_section'
  ],
  data: function(){
    return {
        profilesOpen: false,
        profileId: 1,
        scrolledProfileId: null
    }
  },
  methods: {
      openProfileDetails(profileId){
        // manually focus profile 1 on first open (as focus depends on watching profileId prop in ProfileDetails)
        if(profileId == 1 & !this.$data.profilesOpen){
            document.getElementById('profile_' + profileId).getElementsByClassName('profile-header')[0].focus()
        }
        this.$data.profilesOpen = true;
        this.$data.profileId = profileId;
        
        TweenLite.to(window, 1, {scrollTo:{y: '#icons_wrapper', offsetY: 50}})
      },
      closeProfileDetails(){
        this.$refs.profile_details.stopVideoPlayback();
        this.$data.profilesOpen = false;
        this.$data.profileId = 1;
        this.$data.scrolledProfileId = null;        
      },
      randomRotate(){
          for(let i in this.$refs.profile_icon){
            let angles=[5, 15, 25, 20, -15, -35, -20, -25]
            let angle = angles[Math.floor(Math.random()*angles.length)];
            let times=[0.1, 0.3, 0.5, 0.8, 1]
            let delay = times[Math.floor(Math.random()*times.length)];
            let r = this.$refs.profile_icon[i]
            r.style.transition = 'all ' + delay + 's';
            r.style.transform = 'rotate(' + angle + 'deg)';
          }  
      },
      scrolledToProfile(id){
        if(this.profilesOpen){
            this.scrolledProfileId = id
        }       
      }
  },
  mounted(){
    var dur = this.windowHeight * 1.5
    const scene = this.$scrollmagic.scene({
        triggerElement: '#profiles_wrapper',
        triggerHook: 0,
        duration: dur
    })
    this.randomRotate();
    this.$scrollmagic.addScene(
    scene
        //.addIndicators()
        .on("enter", function(){
            this.randomRotate();
        }.bind(this))
        .on("leave", function(){
            this.closeProfileDetails()
        }.bind(this)) 
    )
    const scene_2 = this.$scrollmagic.scene({
        triggerElement: '#icons_wrapper',
        duration: dur,
        triggerHook: 0
    })
    this.$scrollmagic.addScene(
    scene_2
        //.addIndicators()
        .on("enter", function(){
            this.closeProfileDetails()
            // this.$data.profileId = 1;
        }.bind(this))
       
    )
    
  }
}
</script>


<style scoped>
.highlight span {
    background-color: #ffd93d;
    color: #382e2b;
    box-decoration-break: clone;
    padding: 0 20px;
}

#profiles_wrapper {
    background-color: #382e2b;
    color: white;
    position: relative;
    left: 0;
    transition: left 0.35s ease-out;
}
#profiles_wrapper.open {
    left: -20%;
}
.brown-bg {
    background: url(../../assets/images/composition-pattern-brown.jpg);
    /* background-size: cover; */
    background-repeat: repeat;
}
.rotate {
    transform: rotate(-3deg);
}
.nudge-left {
    margin-left: 0;
}
.nudge-right {
    margin-right: 0;
}
@media (min-width: 992px) {
    .nudge-left {
        margin-left: -100px;
    }
    .nudge-right {
        margin-right: -50px;
    }
}

.name-card-wrapper {
    position: relative;
    /* transform-style: preserve-3d;
    transition: all 1s ease-in-out; */
    perspective: 1000;
    cursor: pointer;
}
.name-card {
  transform-style: preserve-3d;
  transition: all 0.25s ease-in-out;
  width: 100%;
}
.name-card h5 {
    font-size: 26px !important;
}
.side.front {
    position: absolute;
    backface-visibility: hidden;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.side.back {
    backface-visibility: hidden;
    position: relative;
    transform: rotateY(180deg);
    white-space: nowrap;
}
.name-card-wrapper:hover .name-card,
.name-card-wrapper .name-card.active {
    transform: rotateY(180deg);
}
.icon {
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    transition: transform 0.5s;
    margin-left: -30px;
    height: 250px;
    transition: all 0.5s;
    backface-visibility: hidden;
}

#profiles_wrapper #icons_wrapper {
    transition: all 0.5s;
}
#profiles_wrapper.open #icons_wrapper {
    transform: scale(0.65) translateX(50px);
}
@media (min-width: 992px) {
#profiles_wrapper.open #icons_wrapper {
    transform: scale(0.85) translateX(50px);
}
 }
@media (min-width: 1367px) { }
</style>
